export const BETA_VOUCHER_FEATURE_TOGGLE: App.VoucherToggle = 'use-beta-voucher-features'

export function isBetaVoucherFeatureEnabled(voucher: { voucherToggles?: ReadonlyArray<App.VoucherToggle> }): boolean {
  return voucher.voucherToggles?.includes(BETA_VOUCHER_FEATURE_TOGGLE) ?? false
}
